'use strict';

var UserConfig = Backbone.Model.extend({
    urlRoot: '/api/v1/me/config',
    defaults: {
        modelType: 'user_config',
    },
});

module.exports = UserConfig;
